<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header" :class="{ 'page-header--scrolled': headerScrolled }">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button text="" default-href="/showcase"></ion-back-button>
        </ion-buttons>
        <ion-title>Управление подписками</ion-title>
        <ion-buttons slot="end">
          <HeaderMessengerButton />
          <ion-button @click="$router.push('/admin-subscriptions/new')">
            <ion-icon :icon="addOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background events-content" :fullscreen="true" @ionScroll="onContentScroll">
      <div class="ion-padding">
        <p v-if="loading" class="ion-text-center">Загрузка...</p>
        <ion-list v-else lines="full">
          <ion-item
            v-for="sub in subscriptions"
            :key="sub.id"
            button
            @click="$router.push(`/admin-subscriptions/${sub.id}/edit`)"
          >
            <img
              :src="sub.logoPath ? subscriptionsService.logoUrl(sub.logoPath) : defaultLogo"
              slot="start"
              class="sub-logo"
              :alt="sub.title"
            />
            <ion-label>
              <h2>{{ sub.title }}</h2>
              <p v-if="sub.durationDays">{{ sub.durationDays }} {{ durationLabel(sub.durationDays) }}</p>
              <span v-if="sub.deletedAt" class="sub-badge sub-badge-deleted">Удалено</span>
              <span v-else-if="sub.published === false" class="sub-badge sub-badge-draft">Черновик</span>
            </ion-label>
            <ion-button fill="clear" slot="end" @click.stop="$router.push(`/admin-subscriptions/${sub.id}/edit`)">
              <ion-icon :icon="createOutline" class="admin-edit-icon"></ion-icon>
            </ion-button>
          </ion-item>
        </ion-list>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/vue';
import { addOutline, createOutline } from 'ionicons/icons';
import { defineComponent } from 'vue';
import type { ILigaSubscription } from '@/model/liga-subscription.model';
import subscriptionsService from '@/services/subscriptions.service';

import HeaderMessengerButton from '@/components/HeaderMessengerButton.vue';

export default defineComponent({
  name: 'AdminSubscriptionsList',
  components: {
    HeaderMessengerButton,
    IonBackButton,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonPage,
    IonTitle,
    IonToolbar
  },
  data() {
    return {
      subscriptions: [] as ILigaSubscription[],
      loading: true,
      headerScrolled: false,
      subscriptionsService,
      defaultLogo: require('@/theme/liga-logo-white.png'),
      addOutline,
      createOutline
    };
  },
  async mounted() {
    await this.load();
  },
  ionViewWillEnter() {
    void this.load();
  },
  methods: {
    onContentScroll(e: CustomEvent) {
      this.headerScrolled = (e.detail?.scrollTop ?? 0) > 16;
    },
    durationLabel(days: number): string {
      const v = days % 10;
      const v2 = days % 100;
      if (v2 >= 11 && v2 <= 14) return 'дней';
      if (v === 1) return 'день';
      if (v >= 2 && v <= 4) return 'дня';
      return 'дней';
    },
    async load() {
      this.loading = true;
      try {
        this.subscriptions = await subscriptionsService.getSubscriptions(true);
      } catch {
        this.subscriptions = [];
      }
      this.loading = false;
    }
  }
});
</script>

<style scoped>
.sub-logo {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 8px;
  margin-right: 12px;
}
ion-item {
  --background: var(--liga-surface);
  --color: var(--liga-chrome-text);
}
ion-item h2,
ion-item p {
  color: var(--liga-chrome-text);
}
.sub-badge {
  display: inline-block;
  font-size: 0.7rem;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 6px;
}
.sub-badge-draft {
  background: rgba(255, 193, 7, 0.3);
  color: #ffc107;
}
.sub-badge-deleted {
  background: rgba(244, 67, 54, 0.3);
  color: #f44336;
}
.admin-edit-icon {
  color: var(--liga-chrome-text) !important;
}
</style>
